module.exports = globalThis.ort;